import React from 'react';
export const StorySection = () => {
  return <section className="py-16 px-6 md:px-10 bg-cream" data-id="element-288">
      <div className="max-w-4xl mx-auto" data-id="element-289">
        <h2 className="section-title text-center mb-10" data-id="element-290">
          Tu momento de "No puedo más"
        </h2>
        <div className="bg-white p-8 rounded-xl shadow-md mb-12 serif-text text-lg" data-id="element-291">
          <p className="mb-4" data-id="element-292">
            Ese día que estabas cansada, con el café frío, mirando tu cuenta
            vacía. Ese día en que te preguntaste:
          </p>
          <p className="quote text-xl font-semibold my-6" data-id="element-293">
            "¿Cómo puede ser que trabaje tanto… y no vea resultados?"
          </p>
          <p className="mb-4" data-id="element-294">
            Ese día en que tu familia te pidió "solo un poquito…" y tú no tenías
            ni cómo decir que sí ni cómo decir que no.
          </p>
          <p className="mb-4" data-id="element-295">Ese día fue tu punto de quiebre.</p>
          <p data-id="element-296">
            Y ese día es exactamente la razón por la que este método existe.
          </p>
        </div>
        <div className="text-center space-y-4 text-lg max-w-2xl mx-auto" data-id="element-297">
          <p className="font-semibold" data-id="element-298">
            No necesitas más fuerza. Ya eres fuerte.
          </p>
          <p className="font-semibold" data-id="element-299">
            No necesitas más culpa. Ya cargas demasiada.
          </p>
          <p className="font-semibold" data-id="element-300">
            No necesitas trabajar más. Ya das todo.
          </p>
          <p className="text-xl font-bold mt-6" data-id="element-301">
            Lo que necesitabas era esto: Un sistema que finalmente trabaje a tu
            favor.
          </p>
        </div>
      </div>
    </section>;
};